import React from "react";
var __jsx = React.createElement;
import ContentBox from "@/pages/car-comparison/components/ContentBox";
import ContentItem from "@/pages/car-comparison/components/ContentItem";
import { twMerge } from "tailwind-merge";
var PriceSection = function PriceSection(_ref) {
  var details = _ref.details,
    title = _ref.title,
    carStatus = _ref.carStatus;
  var renderPriceText = function renderPriceText(color, value, index, rowIndex) {
    return typeof value === 'object' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      id: "compare-price-value-".concat(rowIndex, "-car-").concat(index + 1),
      className: twMerge(color, 'text-2xl font-bold flex gap-0.5 items-baseline w-full justify-center')
    }, carStatus[index] !== 'sold' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      id: "compare-price-amount-".concat(rowIndex, "-car-").concat(index + 1)
    }, value.price), /*#__PURE__*/React.createElement("span", {
      id: "compare-price-unit-".concat(rowIndex, "-car-").concat(index + 1),
      className: "text-xs"
    }, value.text)))) : /*#__PURE__*/React.createElement(React.Fragment, null, carStatus[index] !== 'sold' && /*#__PURE__*/React.createElement("span", {
      id: "compare-price-value-".concat(rowIndex, "-car-").concat(index + 1),
      className: twMerge(color, 'text-xs font-bold gap-0.5 items-baseline w-full justify-center')
    }, /*#__PURE__*/React.createElement("span", {
      id: "compare-price-amount-".concat(rowIndex, "-car-").concat(index + 1)
    }, value)));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "compare-price-section",
    className: "md:max-w-[767px] md:m-auto md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement("p", {
    id: "compare-price-title",
    className: "text-sm font-bold text-gray-text text-start"
  }, title), /*#__PURE__*/React.createElement(ContentBox, {
    id: "compare-price-box"
  }, details.map(function (detail, index) {
    var color = (detail === null || detail === void 0 ? void 0 : detail.key) === 'cash_price' ? 'text-success' : 'text-primary';
    if (detail.values.length === 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement(ContentItem, {
      id: "compare-price-row-".concat(index),
      titleId: "compare-price-row-label-".concat(index),
      rightId: "compare-price-row-right-".concat(index),
      leftId: "compare-price-row-left-".concat(index),
      key: (detail === null || detail === void 0 ? void 0 : detail.title) + index,
      centerTitleDesktop: true,
      itemTitle: detail === null || detail === void 0 ? void 0 : detail.title,
      rightNode: renderPriceText(color, detail === null || detail === void 0 ? void 0 : detail.values[0], 0, index),
      leftNode: renderPriceText(color, detail === null || detail === void 0 ? void 0 : detail.values[1], 1, index),
      titleInside: false,
      hasTitle: false
    });
  })))));
};
export default PriceSection;